import { useState, useEffect } from "react";
import styled from "styled-components";
import { NavBar } from "../../../components/navbar/navbar.component";
import HEADERIMAGE from "../../../assets/header-image2.png";
import APPLEPLAYICON from "../../../assets/apple-store-icon.png";
import GOOGLEPLAYICON from "../../../assets/play-store-icon.png";
import { Modal } from "../../../components/modal/modal.component";
import { Button } from "../../../components/typography/button.component";
import OurStrengthImg1 from "../../../assets/our-strength-img-1.svg";
import OurStrengthImg2 from "../../../assets/our-strength-img-2.svg";
import OurStrengthImg3 from "../../../assets/our-strength-img-3.svg";
import OurStrengthImg4 from "../../../assets/our-strength-img-4.svg";
import BackgroundImage from "../../../assets/bg.png";
import { Trans } from "react-i18next";
import { useTranslation } from "react-i18next";
/**
 *temporal firebase configs
 */
import { signInAnonymously } from "firebase/auth";
import { auth } from "../../../temporal/firebase";
import { Link } from "react-router-dom";
import { OurServices } from "../components/ourservices.component";
import { PartnerWithUs } from "../components/partner-with-us.component";
import { AboutUs } from "../components/about-us.component";
import { Footer } from "../../../components/footer/footer.component";
import { HamburgerMenu } from "../../../components/HamburgerMenu/hamburgermenu.component";
import { ImageSkeleton } from "../../../components/skeletons/image-skeletons";

const HomeReset = styled.div`
  & * {
    margin: 0;
    box-sizing: border-box;
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

const HomeContainer = styled.div`



    width: 100%
    max-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (max-width: 1025px) {
    max-width: 1000px;
    };
    @media (max-width: 480px) {
    max-width: 460px; 
    };
`;
const Header = styled.div`
  width: 100%;
  max-width: 1400px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 80px 0;
  height: 100%;
  @media (max-width: 1025px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100vh);
    padding: 0px 0 32px 0;
  }
`;
const headerBlock = styled.div`
  background: url(${BackgroundImage}) center center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: grid;
  place-items: center;
`;
const HeaderDescription = styled.div`
  width: 46%;

  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    font-size: 32px;
    width: 100%;
    max-width: 415px;
  }
  @media (max-width: 380px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 32px;
  }
`;
const HeaderHeading = styled.p`
  font-weight: 700;
  font-size: 40px;
  line-height: 48px;
  letter-spacing: 2px;
  @media (max-width: 1025px) {
    text-align: center;
  }
  @media (max-width: 480px) {
    width: 100%;
    max-width: 400px;
    font-size: 24px;
    line-height: 32px;
  }
`;
const HeaderPara = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0%;
  max-width: 560px;
  @media (max-width: 1025px) {
    font-size: 18px;
    text-align: center;
    padding: 14px 0 14px 0;
  }
  @media (max-width: 480px) {
    text-align: center;
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 370px;
    line-height: 24px;
    padding-top: 8px;
    font-size: 14px;
  }
  @media (max-width: 380px) {
    max-width: 300px;
  }
`;
const Span = styled.span`
  color: rgba(29, 109, 193, 1);
`;

const HeaderButtons = styled.div`
  display: flex;
  width: 100%;
  max-width: 432px;
  justify-content: space-between;
  margin-top: 12px;
  @media (max-width: 1025px) {
    padding: 14px 0 48px 0;
  }
  @media (max-width: 480px) {
    max-width: 320px;
    padding: 8px 0 18px 0;
  }
  @media (max-width: 380px) {
    max-width: 300px;
  }
`;
const HeaderImageWrapper = styled.figure`
  width: 100%;
  max-width: 552.2px;
  height: 100%;
  max-height: 581.1px;
  background-color: inherit;
  @media (max-width: 480px) {
    max-width: 378px;
    margin: 32px 0 32px 0;
    max-height: 400px;
  }
  @media (max-width: 380px) {
    max-width: 300px;
  }
`;
const ButtonImageWrapper = styled.figure`
  width: 100%;
  max-width: 14px;
  height: 100%;
  max-height: 14px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Image = styled.img`
  width: 100%;
  background-color: inherite;
  height: 100%;
`;
const OurStrengthsContainer = styled.div`
  min-width: 100%;
  background-color: rgba(1, 48, 99, 1);
  display: flex;
  justify-content: center;
`;
const OurStrengths = styled.div`
  width: 100%;
  max-width: 1400px;
  display: flex;
  justify-content: center;
  padding: 32px 0 32px 0;
  @media (max-width: 1025px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;
const OurStrengthDesc = styled.div`
  width: 100%;
  max-width: 40%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 1025px) {
    max-with: 90%;
    align-items: center;
  }
  @media (max-width: 480px) {
    max-with: 90%;
    align-items: center;
  }
`;
const OurStrengthDescHeading = styled.p`
  color: rgba(255, 252, 252, 1);
  font-weight: 700;
  font-size: 20px;
  @media (max-width: 380px) {
    min-width: 370px;
  }
`;
const OurStrengthDescPara = styled.p`
  color: rgba(255, 252, 252, 1);
  font-weight: 400;
  font-size: 14px;
  margin-top: 12px;
  line-height: 18px;
  @media (max-width: 1025px) {
    font-size: 14px;
    padding-bottom: 12px;
  }
  @media (max-width: 480px) {
    font-size: 12px;
    min-width: 430px;
    max-width: 435px;
    display: flex;
    justify-content: center;
  }
  @media (max-width: 380px) {
    min-width: 370px;
  }
`;
const OurStrengthPoints = styled.div`
  display: flex;
  @media (max-width: 480px) {
    padding-top: 12px;
  }
  @media (max-width: 380px) {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
`;
const OurStrengthPointsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  @media (max-width: 480px) {
  }
  @media (max-width: 380px) {
    width: calc(100% / 3);
  }
`;
const OurStrengthPointsImgWrapper = styled.figure`
  width: 30px;
  height: 30px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  @media (max-width: 480px) {
    width: 24px;
    height: 24px;
  }
  @media (max-width: 380px) {
  }
`;
const OurStrengthPointsImage = styled.img`
  width: 14px;
  height: 14px;
`;
const OurStrengthPointsPara = styled.p`
  font-size: 14px;
  color: rgba(255, 252, 252, 1);
  margin-top: 12px;
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;
const LinkWhite = styled(Link)`
  color: #fff;
`;

export const Home = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [isPartnerWithUs, setIsPartnerWithUs] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    signInAnonymously(auth).catch(console.error);
  }, []);
  useEffect(() => {
    if (menuIsOpen || isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuIsOpen, isModalOpen]);

  return (
    <>
      {isModalOpen && (
        <Modal
          setModalOpen={setModalOpen}
          isPartnerWithUs={isPartnerWithUs}
          setIsPartnerWithUs={setIsPartnerWithUs}
        />
      )}
      {menuIsOpen && (
        <HamburgerMenu
          menuIsOpen={menuIsOpen}
          setMenuIsOpen={setMenuIsOpen}
          setModalOpen={setModalOpen}
        />
      )}
      <HomeReset
        style={{
          pointerEvents: isModalOpen ? "none" : "auto",
          opacity: isModalOpen ? 0.4 : 1,
          overflow: menuIsOpen ? "hidden" : "auto",
        }}
      >
        <HomeContainer>
          <NavBar
            menuIsOpen={menuIsOpen}
            setMenuIsOpen={setMenuIsOpen}
            setModalOpen={setModalOpen}
          />

          <Header>
            <HeaderDescription>
              <HeaderHeading>
                <Trans
                  i18nKey="header-heading"
                  components={[
                    <Span/>,
                    <Span/>,
                  ]}
                ></Trans>
              </HeaderHeading>
              <HeaderPara>
                {t('header-para')}
              </HeaderPara>
              <HeaderButtons>
                <Button onClick={() => setModalOpen(true)}>
                  {/* <ButtonImageWrapper>
                    <Image src={APPLEPLAYICON} />
                  </ButtonImageWrapper> */}
                  {t('header-btn')}
                </Button>
                {/* &nbsp;&nbsp;
                <Button>
                  <ButtonImageWrapper>
                    <Image src={GOOGLEPLAYICON} />
                  </ButtonImageWrapper>
                  Get the Android app
                </Button> */}
              </HeaderButtons>
            </HeaderDescription>
            {HEADERIMAGE ? (
              <HeaderImageWrapper>
                <Image src={HEADERIMAGE} alt="" />
              </HeaderImageWrapper>
            ) : (
              <ImageSkeleton />
            )}
          </Header>
          <OurStrengthsContainer>
            <OurStrengths>
              <OurStrengthDesc>
                <OurStrengthDescHeading>
                  {t('our-char')}
                </OurStrengthDescHeading>
                <OurStrengthDescPara>
                  {t('our-char-para')}
                  {/* <LinkWhite to={"/"}>Learn more</LinkWhite> */}
                </OurStrengthDescPara>
              </OurStrengthDesc>
              <OurStrengthPoints>
                <OurStrengthPointsWrapper>
                  <OurStrengthPointsImgWrapper>
                    <OurStrengthPointsImage src={OurStrengthImg4} alt="" />
                  </OurStrengthPointsImgWrapper>
                  <OurStrengthPointsPara>
                    {t('our-char-para-1')}
                  </OurStrengthPointsPara>
                </OurStrengthPointsWrapper>
                <OurStrengthPointsWrapper>
                  <OurStrengthPointsImgWrapper>
                    <OurStrengthPointsImage src={OurStrengthImg3} alt="" />
                  </OurStrengthPointsImgWrapper>
                  <OurStrengthPointsPara>
                    {t('our-char-para-2')}
                  </OurStrengthPointsPara>
                </OurStrengthPointsWrapper>
                <OurStrengthPointsWrapper>
                  <OurStrengthPointsImgWrapper>
                    <OurStrengthPointsImage src={OurStrengthImg2} alt="" />
                  </OurStrengthPointsImgWrapper>
                  <OurStrengthPointsPara>
                    {t('our-char-para-3')}
                  </OurStrengthPointsPara>
                </OurStrengthPointsWrapper>
                <OurStrengthPointsWrapper>
                  <OurStrengthPointsImgWrapper>
                    <OurStrengthPointsImage src={OurStrengthImg1} alt="" />
                  </OurStrengthPointsImgWrapper>
                  <OurStrengthPointsPara>
                    {t('our-char-para-4')}
                  </OurStrengthPointsPara>
                </OurStrengthPointsWrapper>
              </OurStrengthPoints>
            </OurStrengths>
          </OurStrengthsContainer>
          <AboutUs
            setModalOpen={setModalOpen}
            setIsPartnerWithUs={setIsPartnerWithUs}
          />
          <OurServices />
          <PartnerWithUs
            setModalOpen={setModalOpen}
            setIsPartnerWithUs={setIsPartnerWithUs}
          />
          <Footer setModalOpen={setModalOpen} />
        </HomeContainer>
      </HomeReset>
    </>
  );
};
